import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Field,
  reduxForm,
  stopSubmit,
  getFormValues,
  FieldArray,
} from 'redux-form';
import {
  Form,
  FormGroup,
  Label,
  Alert,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';

import TextInput from '../../system/fields/TextInput';
import FileUpload from '../../system/fields/FileUpload';
import List from './components/List';

import * as validations from '../../system/utils/Validation';
import AddressSearch from '../../system/fields/AddressSearch';
import Wysiwyg from '../../system/fields/Wysiwyg';
import SelectDropdown from '../../system/fields/SelectDropdown';
import ReviewsTable from '../Deals/components/ReviewsTable';
import { getOverview } from '../../store/overview';
import Activities from '../City/components/Activites';
import Faq from '../City/components/Faq';

class EditForm extends Component {
  state = {
    activeTab: 1,
  };

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }
  componentDidMount() {
    this.props.dispatch(getOverview());
  }

  render() {
    const { handleSubmit, mode } = this.props;

    console.log(this.props, 'deano the hun');
    return (
      <section className='edit-form'>
        <Form onSubmit={handleSubmit}>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={this.state.activeTab === 1 ? 'active' : ''}
                onClick={() => this.toggleTab(1)}
              >
                Cruise Line Details
              </NavLink>
            </NavItem>
            {mode === 'edit' && (
              <NavItem>
                <NavLink
                  className={this.state.activeTab === 2 ? 'active' : ''}
                  onClick={() => this.toggleTab(2)}
                >
                  Order Ships
                </NavLink>
              </NavItem>
            )}
            <NavItem>
              <NavLink
                className={this.state.activeTab === 3 ? 'active' : ''}
                onClick={() => {
                  this.toggleTab(3);
                }}
              >
                Reviews
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={this.state.activeTab === 4 ? 'active' : ''}
                onClick={() => {
                  this.toggleTab(4);
                }}
              >
                Activities
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={this.state.activeTab === 5 ? 'active' : ''}
                onClick={() => {
                  this.toggleTab(5);
                }}
              >
                F&amp;Q's
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={this.state.activeTab}>
            <TabPane tabId={1}>
              <section className='form-section'>
                <div className='row'>
                  <FormGroup className='col-12 col-sm-6'>
                    <Label>Cruise Line Name</Label>
                    <Field
                      name='name'
                      component={TextInput}
                      placeholder='Cruise Line Name'
                      type='text'
                    />
                  </FormGroup>
                  <FormGroup className='col-12 col-sm-6'>
                    <Label>Sub Title</Label>
                    <Field
                      name='subtitle'
                      component={TextInput}
                      placeholder='Sub Title'
                      type='text'
                    />
                  </FormGroup>
                  <FormGroup className="col-12 col-sm-4">
                        <Label>Slug</Label>
                        <Field
                             name='slug'
                             placeholder='Cruise Line Slug'
                             component={TextInput}
                             type='text'
                        />
                    </FormGroup>
                </div>

                <div className='row'>
                  <FormGroup className='col-12'>
                    <Label>Top Description (Summary)</Label>
                    <Field
                      name='summary'
                      component={Wysiwyg}
                      placeholder='Summary'
                      className='form-control'
                      type='text'
                      validate={validations.required}
                    />
                  </FormGroup>
                </div>

                <div className='row'>
                  <FormGroup className='col-12'>
                    <Label>Top Description Cruise &amp; Stay (Summary)</Label>
                    <Field
                      name='cruise_summary'
                      component={Wysiwyg}
                      placeholder='Summary'
                      className='form-control'
                      type='text'
                    />
                  </FormGroup>
                </div>

                <div className='row'>
                  <FormGroup className='col-12'>
                    <Label>Description</Label>
                    <Field
                      name='description'
                      component={Wysiwyg}
                      placeholder='Summary'
                      className='form-control'
                      type='text'
                    />
                  </FormGroup>
                </div>

                <div className='row'>
                  <FormGroup className='col-12'>
                    <Label>Description Cruise &amp; Stay </Label>
                    <Field
                      name='cruise_description'
                      component={Wysiwyg}
                      placeholder='Summary'
                      className='form-control'
                      type='text'
                    />
                  </FormGroup>
                </div>

                <div className='row'>
                  <FormGroup className='col-12'>
                    <Label>Hero Image</Label>
                    <p className='instruction'>
                      Images must be 1920 x 1080 or bigger in the same aspect
                      ratio
                    </p>
                    <Field
                      name='banner_image'
                      component={FileUpload}
                      files={false}
                      images={true}
                      type='text'
                      className='form-control'
                    />
                  </FormGroup>
                </div>
                <div className={'row'}>
                  <FormGroup className={'col-12 col-sm-6'}>
                    <Label>Multi Center Region</Label>
                    <Field
                      name={'multi_center_region'}
                      component={SelectDropdown}
                      options={this.props.multiCenterRegions}
                      valueKey={'id'}
                      labelKey={'name'}
                    />
                  </FormGroup>
                  <FormGroup className={'col-12 col-sm-6'}>
                    <Label>Video Link</Label>
                    <Field
                      name={'video_link'}
                      component={TextInput}
                      type={'text'}
                    />
                  </FormGroup>
                </div>
              </section>
            </TabPane>
            <TabPane tabId={2}>
              <section className='form-section'>
                <div className='row'>
                  <FormGroup className='col-12 col-sm-6'>
                    <Label htmlFor='email'>Reorder Ships</Label>
                    <Field
                      name='ships'
                      component={List}
                      type='text'
                      itemsDisabled={true}
                    />
                  </FormGroup>
                </div>
              </section>
            </TabPane>
            <TabPane tabId={3}>
              <ReviewsTable
                data={this.props.reviews}
                dispatch={this.props.dispatch}
                formValues={this.props.formValues}
                initialValues={this.props.initialValues}
                formType='CruiseLineForm'
              />
            </TabPane>
            <TabPane tabId={4}>
              <FieldArray name={'activities'} component={Activities} />
            </TabPane>
            <TabPane tabId={5}>
              <FieldArray name={'faqs'} component={Faq} />
            </TabPane>
          </TabContent>
        </Form>

        {this.props.submitFailed && (
          <div className='error-container'>
            <Alert color='danger'>
              <strong>There are errors in your form.</strong>
              <br />
              Please check before submitting again.
            </Alert>
          </div>
        )}
      </section>
    );
  }
}

EditForm = reduxForm({
  form: 'CruiseLineForm',
  onChange: (values, dispatch, props) => {
    if (props.error || props.submitFailed) {
      dispatch(stopSubmit('CruiseLineForm'));
    }
  },
  destroyOnUnmount: false,
})(EditForm);

const mapStateToProps = (state) => {
  return {
    cruiseLines: state.overview.cruiseLines,
    ships: state.overview.ships,
    reviews: state.overview.reviews,
    formValues: getFormValues('CruiseLineForm')(state),
  };
};

export default connect(mapStateToProps)(EditForm);



// WEBPACK FOOTER //
// ./src/containers/CruiseLines/Form.jsx